import Backend from 'App/Dataman-Backend';

const {
  apiUrlEvents,
  apiUrlSuffix,
  apiUrlEventTypes,
  apiUrlEventThemes,
  apiUrlAttendingRequests,
  apiUrlEventAtendingRequest,
  apiUrlEventImages,
} = Backend.config;

export const EVENTS_PATHS = {
  events: apiUrlEvents,
  suffix: apiUrlSuffix,
  eventTypes: apiUrlEventTypes,
  eventThemes: apiUrlEventThemes,
  attendingRequests: apiUrlAttendingRequests,
  eventAtendingReports: apiUrlEventAtendingRequest,
  eventImages: apiUrlEventImages,
};
